let loadPromise = null;
const mounted = new Set();

function loadScript() {
  if (window.initComponent) return Promise.resolve();
  if (!loadPromise) {
    loadPromise = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = "https://standalone.api.sportigo.fr/component-standalone.js";
      s.async = true;
      s.onload = () => resolve();
      s.onerror = () => reject(new Error("Sportigo script failed to load"));
      document.body.appendChild(s);
    });
  }
  return loadPromise;
}

export async function mountSportigo(component, containerId, gymId, options) {
  try {
    await loadScript();
  } catch (e) {
    return;
  }
  if (mounted.has(containerId)) return;
  if (!document.getElementById(containerId)) return;
  mounted.add(containerId);
  window.initComponent(component, containerId, gymId, options);
}
